import React, { useState } from 'react'
import Select from '../SelectComponent/SelectComponent'
import Input from '../Input/Input'
import Button from '@mui/material/Button'
import AutoComplete from '../autoComplete/AutoComplete'
import './filter.scss'

interface FilterComponentProps {
  filterData?: (filters: Array<Record<string, string>>) => void
  customerList?: string[]
  isInternal?: boolean
  reportTypeList?: string[]
  frequencyList?: string[]
}

const FilterComponent: React.FC<FilterComponentProps> = ({
  filterData = () => {},
  customerList = [],
  isInternal = false,
  reportTypeList = [],
  frequencyList = []
}) => {
  const [disablebt, setdisablebt] = useState(true)
  const [selOptions, setselOptionsVal] = useState<string[]>([])
  const [selFilter, setSelFilter] = useState<Array<Record<string, string>>>([])
  const [reportSearch, setreportSearch] = useState('')
  const [resetVal, setResetVal] = useState(false)

  const handleSelect = (options: string[], resetFlag?: boolean) => {
    if (resetFlag) {
      setResetVal(false)
      setSelFilter([])
      setselOptionsVal([])
      setdisablebt(true)
      filterData([])
      return
    }
    const filterObj = [...selFilter]
    if (filterObj.length > options.length) {
      const index = filterObj.findIndex(obj => !options.includes(Object.keys(obj)[0]))
      if (index !== -1) {
        filterObj.splice(index, 1)
      }
    }
    for (const opt of options) {
      if (!selOptions.includes(opt)) {
        const obj: Record<string, string> = {}
        obj[opt] = ''
        filterObj.push(obj)
      }
    }
    setSelFilter(filterObj)
    setselOptionsVal(options)
    setdisablebt(true)
  }

  const setSelected = (value: string | string[], type = '') => {
    const selectedValue = Array.isArray(value) ? value[0] || '' : value
    const updatedOptions = [...selFilter]
    let disabledCount = 0

    updatedOptions.forEach((option) => {
      const key = Object.keys(option)[0]
      if (key === 'Frequency' && type === 'Frequency') {
        option.Frequency = selectedValue === 'Frequency' ? '' : selectedValue
      } else if (key === 'Report Type' && type === 'Report Type') {
        option['Report Type'] = selectedValue === 'Report Type' ? '' : selectedValue
      }
      if ((Object.values(option)[0] ?? '').toString().trim() !== '') {
        disabledCount += 1
      }
    })

    setdisablebt(selOptions.length !== disabledCount)
    setSelFilter(updatedOptions)
  }

  const setInputValue = (key: string, text: string) => {
    const updatedOptions = [...selFilter]
    let disabledCount = 0

    updatedOptions.forEach((option) => {
      const optionKey = Object.keys(option)[0]
      if (optionKey === key) {
        option[key] = text
        if (key === 'Report Name') {
          setreportSearch(text)
        }
      }
      if ((Object.values(option)[0] ?? '').toString().trim() !== '') {
        disabledCount += 1
      }
    })

    setdisablebt(selOptions.length !== disabledCount)
    setSelFilter(updatedOptions)
  }

  const formFilterData = () => {
    filterData(selFilter)
  }

  const handleReset = () => {
    setResetVal(true)
    setdisablebt(true)
    setreportSearch('')
    setSelFilter([])
    setselOptionsVal([])
    filterData([])
  }

  return (
    <div className='metlife-filter-main'>
      <Select
        defaultValue='Search by'
        className='filter-dropdown'
        options={isInternal ? ['Search by', 'Customer Name', 'Report Name', 'Frequency', 'Report Type'] : ['Search by', 'Report Name', 'Frequency', 'Report Type']}
        onSelect={handleSelect}
        multiSelect
        reset={resetVal}
      />
      {selOptions.indexOf('Customer Name') > -1 && (
        <AutoComplete onSelect={setInputValue} suggestionList={customerList} defaultValue='Customer Name' />
      )}
      {selOptions.indexOf('Report Name') > -1 && (
        <Input
          id='search-text'
          defaultValue='Report Name'
          value={reportSearch}
          label='Search'
          variant='outlined'
          className='filter-textbox'
          onChange={setInputValue}
        />
      )}
      {selOptions.indexOf('Frequency') > -1 && (
        <Select
          defaultValue='Frequency'
          key='Frequency'
          options={frequencyList}
          className='frequency-dropdown'
          onSelect={(value) => setSelected(value, 'Frequency')}
        />
      )}
      {selOptions.indexOf('Report Type') > -1 && (
        <Select
          defaultValue='Report Type'
          key='Report Type'
          options={reportTypeList}
          className='frequency-dropdown'
          onSelect={(value) => setSelected(value, 'Report Type')}
        />
      )}
      <div>
        {selOptions.length > 0 && (
          <Button variant='contained' disableElevation className={disablebt ? 'filter-button disabled' : 'filter-button'} onClick={formFilterData}>
            {'FIND'}
          </Button>
        )}
        {selOptions.length > 0 && (
          <button aria-label='refresh data' onClick={handleReset} className='refresh-cls'>
            Clear Filter
          </button>
        )}
      </div>
    </div>
  )
}

export default FilterComponent
